import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SchematicDataVM } from '../setup-implement/setup-implement.model';
import { AddObservationPointComponent } from '../add-observation-point/add-observation-point.component';
import { MatDialog } from '@angular/material/dialog';



@Component({
    selector: 'draggable-schematic',
    templateUrl: './draggable-schematic.component.html',
    styleUrls: ['./draggable-schematic.component.scss']
})
export class DraggableSchematicComponent implements OnInit {

    @Input() positionX: string = "500";
    @Input() positionY: string = "500";
    @Input() schematic: SchematicDataVM = new SchematicDataVM();
    @Input() title: string = "Schematic";

    @Input() mouseoverMPId: number = 0;
    @Input() mouseoverOPId: number = 0;

    @Input() CustomerId: number ;
    @Input() ImplementId: number ;

    @Output() mouseoverMP: EventEmitter<number> = new EventEmitter();
    @Output() mouseoverOP: EventEmitter<number> = new EventEmitter();
    @Output() closeSchematicWindow: EventEmitter<boolean> = new EventEmitter();




    
    //  window.
    showSchematic: boolean = false;
    schematicPositionX: number;
    schematicPositionY: number;
    draggableSchematicTitle: string = "Schematic";

     // Mouse events for draggable schematic window.
     isMouseDown: boolean = false;
     prevMouseX: number;
     prevMouseY: number;
     selectedSchematic: SchematicDataVM;
     showAddObservation:boolean=false;
     eventX :number
     eventY :number
     
    constructor(private _sanitizer: DomSanitizer,
        public openObservationPointModel:MatDialog) { }

    ngOnInit() {

    }

    

    onCloseClick(): void {
        this.closeSchematicWindow.emit(true);
    }

    getImage(image: string) {
        return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
    }

    setWindowPosition(posX: string, posY: string) {
        return this._sanitizer.bypassSecurityTrustStyle('Left: ' + posX + 'px;' + 'Top: ' + posY + 'px;' + 'Position: absolute; z-index: 10;');
    }

    getPosition(posX: string, posY: string) {
        var iPX = (parseFloat(posX));
        var iPY = (parseFloat(posY));
        return this._sanitizer.bypassSecurityTrustStyle('Left: ' + iPX.toString() + 'px;' + 'Top: ' + iPY.toString() + 'px;' + 'Position: absolute;');
    }

    getEval(wornPct: number, inspectDate: string) {
        if ((wornPct == 0) && (inspectDate == "Never")) {
            return 'gray';
        } else if (wornPct <= 30) {
            return 'green';
        } else if ((wornPct > 30) && (wornPct <= 60)) {
            return 'yellow';
        } else if ((wornPct > 60) && (wornPct <= 80)) {
            return 'orange';
        } else if (wornPct > 80) {
            return 'red';
        }
    }

    onMouseOverMP(id) {
        this.mouseoverMP.emit(id);
    }

    onMouseOutMP(id) {
        this.mouseoverMP.emit(0);
    }

    onMouseOverOP(id) {
        this.mouseoverOP.emit(id);
    }

    onMouseOutOP() {
        this.mouseoverOP.emit(0);
    }


     openObservationPointModal(event) {
        this.showAddObservation=true;
        this.eventX =  event.offsetX-50;
        this.eventY =  event.offsetY-50;
    //     let openOPModalRef = this.openObservationPointModel.open(AddObservationPointComponent, {
    //         width: '650px',
    //         hasBackdrop: false,
    //         data: {
    //             "x": event.offsetX-50,
    //             "y": event.offsetY-50,
    //             customerId:   this.CustomerId,
    //             implemepntId:this.ImplementId,
    //             Schematic:this.selectedSchematic
    //         }
    //     });
    //     openOPModalRef.afterClosed().subscribe(() => {
    //        // this.reloadDetails();
    //     });
    }



}
